import { render, staticRenderFns } from "./dress.vue?vue&type=template&id=afe073f8&scoped=true"
import script from "./dress.vue?vue&type=script&lang=js"
export * from "./dress.vue?vue&type=script&lang=js"
import style0 from "./dress.vue?vue&type=style&index=0&id=afe073f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe073f8",
  null
  
)

export default component.exports